import React, {useCallback, useEffect, useState} from 'react';
import NetworkCharts from "../../../components/Chart/NetworkCharts";
import {SquareOfSolidarityApi} from "../../services/SquareOfSolidarity/services";
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import Report from "./Report";
import { readBuilderProgram } from 'typescript';

const QraphChart = (props) => {
    const [square, setSquare] = useState(null)
    const [data, setData] = useState(null)
    const [page, setPage] = useState('chart')
    const [id, setId] = useState(null)
    const [timestamp, setTimestamp] = useState(props.timestamp ? props.timestamp : 1)

    useEffect(()=>{
        if(props.timestamp!==timestamp){
            setPage('chart')
        }
    },[props.timestamp])

    const Square = useCallback(async () => {
        const square = await SquareOfSolidarityApi(10)
        setSquare(square?.data)
        let data = []
        let nodes = [{
            id: 'تعیین کننده ها',
            marker: {
                radius: 60,
            },
            color: "#ff8d72"
        }]
        await square?.data.map(sq => {
            data.push([sq.title, 'تعیین کننده ها'])
            nodes.push({
                id: sq.title,
                marker: {
                    radius: 50,
                },
                catId: sq.id,
                color: "#1e64f5"
            })
        })
        setData({data: data, nodes: nodes})
    })
    useEffect(() => {
        Square()
    }, [])

    const ClickHandler = (id) => {
        setId(id)
        setPage('tabs')
    }

    return (<>
            {page==='chart' && <Card className={"h-100"}>
                <CardHeader>
                    <Row>
                        <Col className="text-right font-weight-600" sm="6">
                            <h5 className="card-category font-weight-600">تعیین کننده ها</h5>
                        </Col>
                    </Row>
                </CardHeader>
                <CardBody className={"text-center"}>
                    {data && <NetworkCharts ClickHandler={ClickHandler} data={data}/>}
                </CardBody>
            </Card>}
            {page==='tabs' && <Card className={"h-100"}>
                <CardHeader>
                    <Row>
                        <Col className="text-right font-weight-600" sm="6">
                            <h5 className="card-category font-weight-600">تعیین کننده ها</h5>
                        </Col>
                    </Row>
                </CardHeader>
                <CardBody className={"text-center"}>
                    <Report id={id} changePage={()=>setPage('chart')} />
                </CardBody>
            </Card>}
        </>
    );
}
export default QraphChart;